import React, { useState } from 'react'
import { Col } from 'react-bootstrap'
import { trans } from 'sharedKernel/i18n'
import { useGetConnectionFunnel, type ScoutingOpportunity } from '../api/scoutingService'
import type { ScoutingOpportunityFile } from '../scoutingOpportunityDisplay'
import { ScoutingAbout } from './components/ScoutingAbout'
import { ScoutingDetailCover } from './components/ScoutingDetailCover'
import { ScoutingInterestedStartups } from './components/ScoutingInterestedStartups'
import { SidebarItem, SidebarWrapper, AboutContentColumn, VisualizationContainer, VisualizationLayoutRow } from './style'

interface ScoutingVisualizationScreenProps {
  data: ScoutingOpportunity | null | undefined
  fileRows?: ScoutingOpportunityFile[] | null
}

export const ScoutingVisualizationScreen = ({
  data,
  fileRows
}: ScoutingVisualizationScreenProps): JSX.Element => {
  const [activeTab, setActiveTab] = useState<'about' | 'interested'>('about')

  const opportunityId = data?.id

  useGetConnectionFunnel(opportunityId ?? '')

  const menuItems = [
    {
      key: 'about' as const,
      label: trans('Sobre a oportunidade')
    },
    {
      key: 'interested' as const,
      label: trans('Startups interessadas')
    }
  ]

  return (
    <VisualizationContainer fluid>
      <ScoutingDetailCover data={data} />

      <VisualizationLayoutRow>
        <Col md={3} className="mb-4">
          <SidebarWrapper>
            {menuItems.map(item => (
              <SidebarItem
                key={item.key}
                isActive={activeTab === item.key}
                type="button"
                onClick={() => setActiveTab(item.key)}
              >
                {item.label}
              </SidebarItem>
            ))}
          </SidebarWrapper>
        </Col>

        <AboutContentColumn md={9}>
          {activeTab === 'about' && (
            <ScoutingAbout data={data} fileRows={fileRows} />
          )}
          {activeTab === 'interested' && (
            <ScoutingInterestedStartups opportunityId={opportunityId} />
          )}
        </AboutContentColumn>
      </VisualizationLayoutRow>
    </VisualizationContainer>
  )
}
